import {useEffect} from "react"

export const OutsideClick = (ref, callback) => {
  useEffect(() => {
    document.addEventListener("mousedown", handleClick)

    return () => {
      document.removeEventListener("mousedown", handleClick)
    }
  })

  const handleClick = (e) => {
    if (ref.current && ref.current.contains(e.target)) {
      //inside click
      return
    }
    //outside click
    callback()
  }
}
